import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Batch } from '@/types/cbs';

interface CBSBatchStore {
  activeBatch: Batch | null;
  batches: Batch[];
  
  setActiveBatch: (batch: Batch | null) => void;
  addBatch: (batch: Batch) => void;
  updateBatch: (id: string, updates: Partial<Batch>) => void;
  endBatch: (id: string, actualHarvestDate: string) => void;
  getBatchById: (id: string) => Batch | undefined;
  clearBatches: () => void;
}

export const useCBSBatchStore = create<CBSBatchStore>()(
  persist(
    (set, get) => ({
      activeBatch: null,
      batches: [],
      
      setActiveBatch: (batch) => set({ activeBatch: batch }),
      
      addBatch: (batch) => set((state) => ({
        batches: [batch, ...state.batches],
        activeBatch: batch,
      })),
      
      updateBatch: (id, updates) => set((state) => ({
        batches: state.batches.map((b) =>
          b.id === id ? { ...b, ...updates } : b
        ),
        activeBatch: state.activeBatch?.id === id
          ? { ...state.activeBatch, ...updates }
          : state.activeBatch,
      })),
      
      endBatch: (id, actualHarvestDate) => set((state) => ({
        batches: state.batches.map((b) =>
          b.id === id
            ? { ...b, batch_status: 'completed' as const, actual_harvest_date: actualHarvestDate }
            : b
        ),
        activeBatch: state.activeBatch?.id === id ? null : state.activeBatch,
      })),
      
      getBatchById: (id) => get().batches.find((b) => b.id === id),
      
      clearBatches: () => set({ activeBatch: null, batches: [] }),
    }),
    {
      name: 'cbs-batch-storage',
      version: 2,
      migrate: (persistedState: any, version: number) => {
        if (version < 2) {
          return { activeBatch: null, batches: [] };
        }
        return persistedState;
      },
    }
  )
);
